import React from 'react'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined'
import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined'

/*
/ Funções
/ 1 - Master Flag
/ 2 - Flag Suporte
/ 3 - Master Froneri
/ 4 - Gerente Froneri
/ 5 - Auxiliar de Vendas Broker
/ 6 - Vendedor Broker
/ 7 - Gerente Vendas Broker
/ 8 - Supervisor Vendas Broker
/ 9 - Socio Proprietario Broker
*/

const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <HomeOutlinedIcon className="icon-sidebar-material-ui" />,
    dscPage: 'Dashboard',
    perfis: [],
  },
  /* {
    component: CNavTitle,
    name: 'Theme',
  },
  {
    component: CNavItem,
    name: 'Colors',
    to: '/theme/colors',
    icon: <CIcon icon={cilDrop} customClassName="nav-icon info-sidebar-icon" />,
  },
  {
    component: CNavItem,
    name: 'Typography',
    to: '/theme/typography',
    icon: <CIcon icon={cilPencil} customClassName="nav-icon info-sidebar-icon" />,
  },
  {
    component: CNavTitle,
    name: 'Components',
  }, */
  {
    component: CNavGroup,
    name: 'Usuários',
    to: '/usuarios',
    icon: <PeopleAltOutlinedIcon className="icon-sidebar-material-ui" />,
    dscPage: 'Usuários',
    perfis: [1, 2, 3],
    items: [
      {
        component: CNavItem,
        name: ' - Cadastros',
        to: '/usuarios/',
        dscPage: 'Cadastro usuário',
        perfis: [1, 2, 3],
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Clientes',
    to: '/clientes',
    icon: <GroupsOutlinedIcon className="icon-sidebar-material-ui" />,
    dscPage: 'Clientes',
    perfis: [],
    items: [
      {
        component: CNavItem,
        name: ' - Exportação JDE',
        to: '/clientes/exportacao',
        dscPage: 'Exportação JDE',
        perfis: [],
      },
      {
        component: CNavItem,
        name: ' - Cadastro',
        to: '/clientes/cadastro',
        dscPage: 'Cadastro cliente',
        perfis: [],
      },
      {
        component: CNavItem,
        name: ' - Aprovação',
        to: '/clientes/aprovacao',
        dscPage: 'Aprovação clientes',
        perfis: [],
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Auditoria',
    to: '/auditoria',
    icon: <ListAltOutlinedIcon className="icon-sidebar-material-ui" />,
    dscPage: 'Auditoria',
    perfis: [],
    items: [
      {
        component: CNavItem,
        name: ' - Controle de usuário',
        to: '/auditoria/controle-usuarios',
        dscPage: 'Auditoria Controle de usuário',
        perfis: [],
      },
      {
        component: CNavItem,
        name: ' - Controle de aprovação',
        to: '/auditoria/controle-aprovacao',
        dscPage: 'Auditoria Controle de aprovação',
        perfis: [],
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Relatório',
    to: '/relatorios',
    icon: <BallotOutlinedIcon className="icon-sidebar-material-ui" />,
    dscPage: 'Relatório',
    perfis: [],
    items: [
      {
        component: CNavItem,
        name: ' - Análise de cadastro',
        to: '/relatorios/analise-cadastro',
        dscPage: 'Relatório análise de cadastro',
        perfis: [],
      },
    ],
  },
  /* {
    component: CNavGroup,
    name: 'Buttons',
    to: '/buttons',
    icon: <CIcon icon={cilCursor} customClassName="nav-icon info-sidebar-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Buttons',
        to: '/buttons/buttons',
      },
      {
        component: CNavItem,
        name: 'Buttons groups',
        to: '/buttons/button-groups',
      },
      {
        component: CNavItem,
        name: 'Dropdowns',
        to: '/buttons/dropdowns',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Forms',
    icon: <CIcon icon={cilNotes} customClassName="nav-icon info-sidebar-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Form Control',
        to: '/forms/form-control',
      },
      {
        component: CNavItem,
        name: 'Select',
        to: '/forms/select',
      },
      {
        component: CNavItem,
        name: 'Checks & Radios',
        to: '/forms/checks-radios',
      },
      {
        component: CNavItem,
        name: 'Range',
        to: '/forms/range',
      },
      {
        component: CNavItem,
        name: 'Input Group',
        to: '/forms/input-group',
      },
      {
        component: CNavItem,
        name: 'Floating Labels',
        to: '/forms/floating-labels',
      },
      {
        component: CNavItem,
        name: 'Layout',
        to: '/forms/layout',
      },
      {
        component: CNavItem,
        name: 'Validation',
        to: '/forms/validation',
      },
    ],
  },
  {
    component: CNavItem,
    name: 'Charts',
    to: '/charts',
    icon: <CIcon icon={cilChartPie} customClassName="nav-icon info-sidebar-icon" />,
  },
  {
    component: CNavGroup,
    name: 'Icons',
    icon: <CIcon icon={cilStar} customClassName="nav-icon info-sidebar-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'CoreUI Free',
        to: '/icons/coreui-icons',
        badge: {
          color: 'success',
          text: 'NEW',
        },
      },
      {
        component: CNavItem,
        name: 'CoreUI Flags',
        to: '/icons/flags',
      },
      {
        component: CNavItem,
        name: 'CoreUI Brands',
        to: '/icons/brands',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Notifications',
    icon: <CIcon icon={cilBell} customClassName="nav-icon info-sidebar-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Alerts',
        to: '/notifications/alerts',
      },
      {
        component: CNavItem,
        name: 'Badges',
        to: '/notifications/badges',
      },
      {
        component: CNavItem,
        name: 'Modal',
        to: '/notifications/modals',
      },
      {
        component: CNavItem,
        name: 'Toasts',
        to: '/notifications/toasts',
      },
    ],
  },
  {
    component: CNavItem,
    name: 'Widgets',
    to: '/widgets',
    icon: <CIcon icon={cilCalculator} customClassName="nav-icon info-sidebar-icon" />,
    badge: {
      color: 'info',
      text: 'NEW',
    },
  },
  {
    component: CNavTitle,
    name: 'Extras',
  },
  {
    component: CNavGroup,
    name: 'Pages',
    icon: <CIcon icon={cilStar} customClassName="nav-icon info-sidebar-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Login',
        to: '/login',
      },
      {
        component: CNavItem,
        name: 'Register',
        to: '/register',
      },
      {
        component: CNavItem,
        name: 'Error 404',
        to: '/404',
      },
      {
        component: CNavItem,
        name: 'Error 500',
        to: '/500',
      },
    ],
  },
  {
    component: CNavItem,
    name: 'Docs',
    href: 'https://coreui.io/react/docs/templates/installation/',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon info-sidebar-icon" />,
  }, */
]

export default _nav
